<template>
  <div class="radius-20 work-group-card">
    <div class="row header-card">
      <div class="col-12 pt-2">
        <div class="row">
          <div class="col-9">
            <span class="h4 pl-3">Grupo {{ id + 1 }}</span>
          </div>
          <div class="col-3">
            <div class="counter">{{ list.length }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <draggable
          v-model="list"
          group="students"
          class="drag-container custom-scroll"
          @sort="update"
        >
          <div class="row" v-for="element in list" :key="element.id">
            <div class="col-12 px-4">
              <button class="button default my-2">
                {{ element.firstname }} {{ element.lastname }}
              </button>
            </div>
          </div>
          <unicon
            name="plus-circle"
            fill="#DBDBDB"
            width="100px"
            height="100px"
            class="icon"
            v-if="!list.length"
          />
        </draggable>
      </div>
    </div>
    <div class="row footer-card">
      <div class="col-12 text-end pt-3 text-secondary">
        <span class="pr-4 pointer" @click="remove">Eliminar</span>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
  name: "WorkGroupCard",
  components: {
    draggable,
  },
  props: {
    id: {},
    group: {
      default: null,
    },
  },
  data() {
    return {
      list: [],
    };
  },
  methods: {
    update() {
      this.$emit("update", { id: this.id, items: this.list });
    },
    remove() {
      this.$emit("delete", { id: this.id, items: this.list });
    },
  },
  mounted() {
    if (this.group) {
      this.list = this.group;
    }
  },
};
</script>

<style lang="scss" scoped>
.header-card,
.footer-card {
  min-height: 50px;
}
.work-group-card {
  background: white;
  box-shadow: 0 0px 15px 4px rgba(64, 64, 64, 0.2);
}

.drag-container {
  min-height: 175px;
  background: #efefef;
  max-height: 168px;
  overflow-y: auto;
  overflow-x: hidden;
}

button.default {
  width: 100%;
}

.icon {
  position: absolute;
  left: calc(50% - 50px);
  top: calc(50% - 53px);
}

.counter {
  width: 20px;
  height: 20px;
  color: white;
  background: var(--color-secondary);
  border-radius: 50%;
  text-align: center;
  line-height: 17px;
}
</style>
